import type { FaireProductEntity } from "../../entity_types/product";

export const p_vsntmbbvhx: FaireProductEntity = {
  token: "p_vsntmbbvhx",
  type: "product",
  name: "Christmas Quilt Carryall Tote",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/56c519ee2a0219da0b82fd3839422d050941635a6fb6a8aa14351f64a9a72094.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a0dd7fd733970803f5779c7e3581178ab969f9c3a28c2ef57c5c7738d31c4896.jpeg"
  ],
  priceDollars: 5,
  description: "A carryall tote from our Craft Christmas Collection featuring a double-sided design displaying a craft inspired pattern of Christmas quilt patches. Christmas quilt design is replicated from original art hand painted in a unique watercolor style. Seasonal tote displays a coordinating check pattern with a holiday color palette on the gussets and includes both hand and shoulder straps in red nylon. Our Christmas Quilt tote bag is made from eco-friendly post-consumer material and folds flat for easy storage. A craft themed Christmas tote perfect for a seasonal accessory and great for reusable gift wrapping.",
  tags: [],
  msrpDollars: 9.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:29.745Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
